import {Component} from "react";

import "../assets/playground.css"

class Playground extends Component {


    render() {
        return (
            <div id="playground" className={"playground"}/>

        )
    }

}

export default Playground
